import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import Cookies from 'js-cookie'
import axios from 'axios'
import { BASE_URL } from './commonComponents/ApiEndpoints'
import { useAuth } from './AuthContext'
import ExamMarksheet from './ExamMarksheet'
import MarksheetTemplateShriHit1 from './MarksheetTemplateShriHit1'

/** Matches API / user check for Shri Hit marksheet template */
const isShriHitMarksheetCode = (code) => {
  const normalized = String(code || '').toUpperCase()
  return (
    normalized === 'SHRIHITMARKSHEET' || normalized === 'SHRIHITMARKSHEET1'
  )
}

const getAuthToken = (user) => {
  if (user?.token) return user.token
  try {
    const userCookie = Cookies.get('user')
    return userCookie ? JSON.parse(userCookie)?.token : ''
  } catch {
    return ''
  }
}

const hasShriHitMarksheetTemplate = (templates) => {
  if (!Array.isArray(templates)) return false
  return templates.some(
    (item) =>
      String(item?.template_type || '').toLowerCase() === 'marksheet' &&
      isShriHitMarksheetCode(item?.template_code),
  )
}

/**
 * Student marksheets view route: same template_code handling as /ExamMarksheet,
 * but always renders in view-only mode (no filter box).
 */
export default function StudentMarksheetView() {
  const { user } = useAuth()
  const [loading, setLoading] = useState(true)
  const [useShriHitTemplate, setUseShriHitTemplate] = useState(false)

  useEffect(() => {
    let cancelled = false

    const fetchTemplateCodes = async () => {
      const instituteId = Number(Cookies.get('institute_id'))
      const token = getAuthToken(user)

      if (!Number.isFinite(instituteId) || instituteId <= 0 || !token) {
        if (!cancelled) {
          setUseShriHitTemplate(false)
          setLoading(false)
        }
        return
      }

      try {
        setLoading(true)
        const response = await axios.get(`${BASE_URL}/templates/codes`, {
          params: { template_type: 'marksheet' },
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
            'Institute-Id': instituteId,
          },
        })

        const templates = Array.isArray(response.data?.data)
          ? response.data.data
          : []

        if (!cancelled) {
          setUseShriHitTemplate(hasShriHitMarksheetTemplate(templates))
        }
      } catch {
        if (!cancelled) {
          setUseShriHitTemplate(false)
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    fetchTemplateCodes()
    return () => {
      cancelled = true
    }
  }, [user?.token])

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '50vh' }}
      >
        <Spinner animation="border" role="status" />
      </div>
    )
  }

  return useShriHitTemplate ? (
    <MarksheetTemplateShriHit1 hideFilters />
  ) : (
    <ExamMarksheet hideFilters />
  )
}
